import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import InitialAvatar from 'components/shared/avatar/initial'
import Image from 'react-image'
import NoImage from 'assets/images/default-profile.png'

const AvatarUploader = ({ accept, onDrop, src, initial }) => (
  <div className="flex w-full items-center justify-around mb-5">
    {src ? <Image src={[src, NoImage]} className="rounded-full shadow w-32 h-32 mx-5" /> : <InitialAvatar className="w-32 h-32 mr-3 text-4xl" initial={initial} />}

    <Dropzone
      className="uploader border"
      accept={accept}
      onDrop={onDrop}>
      {({ getRootProps, getInputProps }) => (
        <div className="p-5 rounded text-gray-500 bg-gray-100 border-2 border-dashed cursor-pointer">
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <p className="text-xs">
              Drag n drop your avatar here, or click to select file
            </p>
          </div>
        </div>
      )}
    </Dropzone>
  </div>
);

AvatarUploader.propTypes = {
  accept: PropTypes.string.isRequired,
  onDrop: PropTypes.func.isRequired,
  src: PropTypes.string,
  initial: PropTypes.string,
};

export default AvatarUploader;
